export default __webpack_public_path__ + "static/media/behance-circle.ccb88193.svg";